@if (isSalesForceInternal || isSalesForceExternal) {
  <div class='quick-link'>
    <a href="javascript:void(0)" (click)="submitForm();" class="external-link">
      {{ label || 'Sales Force Test' }}
      <span class="material-symbols-outlined">open_in_new</span>
    </a>
  </div>
}